import template from './cases.pug';

/* @ngInject */
export default function routes($stateProvider) {
  $stateProvider
    .state('main.cases', {
      abstract: true,
      url: '/cases',
      template,
      data: { pageTitle: 'Cases | EBGC' },
    });
}



// WEBPACK FOOTER //
// ./client/app/cases/cases.routes.js